import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../App";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [resetToken, setResetToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [resetting, setResetting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      if (data.token) setResetToken(data.token);
      toast.success("Reset instructions sent!");
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setResetting(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token: resetToken, new_password: newPassword });
      toast.success("Password reset successfully!");
      setTimeout(() => { window.location.href = "/login"; }, 1500);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Reset failed");
    } finally {
      setResetting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-white">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-block mb-8">
          <h1 className="cormorant text-3xl font-light italic">RIVORA JEWELS</h1>
        </Link>

        {!sent ? (
          <>
            <h2 className="text-2xl font-light cormorant mb-2" data-testid="forgot-password-title">Forgot Password</h2>
            <p className="text-zinc-600 mb-8">Enter your email and we'll send you reset instructions.</p>
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-password-form">
              <div>
                <label className="block text-sm text-zinc-700 mb-2">Email</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-zinc-300 px-4 py-3 text-sm focus:outline-none focus:border-zinc-900" required data-testid="forgot-email-input" />
              </div>
              <button type="submit" disabled={loading} className="w-full bg-zinc-900 text-white py-3 uppercase tracking-widest text-xs disabled:opacity-50" data-testid="send-reset-button">
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>
          </>
        ) : (
          <>
            <h2 className="text-2xl font-light cormorant mb-2" data-testid="reset-password-title">Reset Password</h2>
            <p className="text-zinc-600 mb-8">Enter your new password below.</p>
            <form onSubmit={handleReset} className="space-y-4" data-testid="reset-password-form">
              <div>
                <label className="block text-sm text-zinc-700 mb-2">Reset Token</label>
                <input type="text" value={resetToken} onChange={(e) => setResetToken(e.target.value)} className="w-full border border-zinc-300 px-4 py-3 text-sm focus:outline-none focus:border-zinc-900" required data-testid="reset-token-input" />
              </div>
              <div>
                <label className="block text-sm text-zinc-700 mb-2">New Password</label>
                <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="w-full border border-zinc-300 px-4 py-3 text-sm focus:outline-none focus:border-zinc-900" required minLength={6} data-testid="new-password-input" />
              </div>
              <button type="submit" disabled={resetting} className="w-full bg-zinc-900 text-white py-3 uppercase tracking-widest text-xs disabled:opacity-50" data-testid="reset-password-button">
                {resetting ? "Resetting..." : "Reset Password"}
              </button>
            </form>
          </>
        )}

        <p className="text-center text-sm text-zinc-600 mt-6">
          <Link to="/login" className="text-zinc-900 hover:underline">Back to login</Link>
        </p>
      </div>
    </div>
  );
}
